/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Suggest_PlaceholderInputs */

const en_us2_translation_suggest_placeholder = /** @type {(inputs: Translation_Suggest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where it appears, what it says, and how it should read`)
};

const pt_br2_translation_suggest_placeholder = /** @type {(inputs: Translation_Suggest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde aparece, o que diz e como ficaria melhor`)
};

const es_419_translation_suggest_placeholder = /** @type {(inputs: Translation_Suggest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dónde aparece, qué dice y cómo debería decir`)
};

const pt_pt2_translation_suggest_placeholder = /** @type {(inputs: Translation_Suggest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde aparece, o que diz e como ficaria melhor`)
};

const fr_fr2_translation_suggest_placeholder = /** @type {(inputs: Translation_Suggest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où elle apparaît, ce qu’elle dit et comment elle devrait se lire`)
};

const de_de2_translation_suggest_placeholder = /** @type {(inputs: Translation_Suggest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo er steht, was er sagt und wie er lauten sollte`)
};

const it_it2_translation_suggest_placeholder = /** @type {(inputs: Translation_Suggest_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove compare, cosa dice e come dovrebbe essere`)
};

/**
* | output |
* | --- |
* | "Where it appears, what it says, and how it should read" |
*
* @param {Translation_Suggest_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const translation_suggest_placeholder = /** @type {((inputs?: Translation_Suggest_PlaceholderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Suggest_PlaceholderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_translation_suggest_placeholder(inputs)
	if (locale === "es-419") return es_419_translation_suggest_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_suggest_placeholder(inputs)
	if (locale === "fr-FR") return fr_fr2_translation_suggest_placeholder(inputs)
	if (locale === "de-DE") return de_de2_translation_suggest_placeholder(inputs)
	if (locale === "it-IT") return it_it2_translation_suggest_placeholder(inputs)
	return en_us2_translation_suggest_placeholder(inputs)
});
export { translation_suggest_placeholder as "translation.suggest_placeholder" }